import CleaningIndexVue from "@/views/housekeeping/cleaning/CleaningIndex.vue";

const cleaning = [
    {
        path: '/cleaning',
        name: 'cleaning',
        component: CleaningIndexVue
    }
]

export default cleaning;